import axios from '../../../utils/customAxiosUtil';

import qs from 'qs';
import { DronData, IdntfData } from '../models/basisDronModel';

export const dronAPI = {
  list: async (data: string) => {
    const queryString = qs.stringify(data, {
      addQueryPrefix: true,
      arrayFormat: 'repeat'
    });
    return await axios.get(`api/bas/dron/list${queryString}`);
  },

  idntfList: async (id: number) => {
    return await axios.get(`api/bas/dron/idntf/list/${id}`);
  },

  detail: async (id: number) => {
    return await axios.get(`api/bas/dron/detail/${id}`);
  },

  create: async (data: DronData) => {
    const res = await axios.post('api/bas/dron/create', data);
    // const res = await axios.post('api/bas/dron/create', data, {
    //   headers: { 'Content-Type': 'multipart/form-data' }
    // });

    return res;
  },
  idntfCreate: async (data: IdntfData[]) => {
    const res = await axios.post('api/bas/dron/idntf/create', data);

    return res;
  },
  update: async (data: DronData) => {
    const res = await axios.put('api/bas/dron/update', data);

    return res;
  },
  delete: async (id: number) => {
    return await axios.delete(`api/bas/dron/delete/${id}`);
  },
  idntfDelete: async (id: string) => {
    return await axios.delete(`api/bas/dron/idntf/delete/${id}`);
  },
  fileupload: async (file: any) => {
    let form = new FormData();
    form.append('file', file);

    // const res = await axios.post('api/file/upload', form, {
    //   headers: { 'Content-Type': 'multipart/form-data' }
    // });
    const res = await axios.post('api/file/upload', form);

    return res;
  }
};
